import { SxProps, Theme } from '@mui/material/styles';

// Common dialog styles to ensure consistency across the app
export const commonDialogStyles: SxProps<Theme> = {
  '& .MuiDialog-paper': {
    backgroundColor: 'background.default', // Matches the main app background
    backgroundImage: 'none', // Remove any default background gradients
  }
};

// For dialog content that should match the app background
export const dialogContentStyles: SxProps<Theme> = {
  backgroundColor: 'background.default',
}; 